// Tradução com fallback: componentes das telas de uso recebem `intl` por prop (vem da área
// via injectIntl). Sem intl (uso isolado), devolve o texto padrão em pt-BR.
export const t = (intl, id, fallback) => {
  if (intl && typeof intl.formatMessage === 'function') return intl.formatMessage({ id, defaultMessage: fallback });
  return fallback;
};

export default t;
